import { RouteRecordRaw } from "vue-router"

export const mineRoutes: RouteRecordRaw[] = [
  {
    path: "/rightsManagement",
    name: "rightsManagement",
    component: () => import("@/views/mine/rightsManagement.vue")
  },
  // 登录密保设置
  {
    path: "/loginEncryptedSetting",
    name: "loginEncryptedSetting",
    component: () => import("@/views/mine/loginEncryptedSetting.vue")
  },
	// iMath使用管控
	{
    path: "/iMathUseConfig",
    name: "iMathUseConfig",
    component: () => import("@/views/mine/iMathUseConfig.vue")
  },
  // 视力保护设置
  {
    path: "/eyeProtectSetting",
    name: "eyeProtectSetting",
    component: () => import("@/views/mine/eyeProtectSetting.vue")
  },
  // 护眼时间
  {
    path: "/eyeProtectTime",
    name: "eyeProtectTime",
    component: () => import("@/views/mine/eyeProtectTime.vue")
  },
  {
		path: "/accountManagement",
		name: "accountManagement",
		component: () => import("@/views/mine/accountManagement.vue")
	},
  {
		path: "/uploadAvatar",
		name: "uploadAvatar",
		component: () => import("@/views/mine/uploadAvatar.vue")
	},
  {
		path: "/helpCenter",
		name: "helpCenter",
		component: () => import("@/views/mine/helpCenter.vue")
	},
	{
		path: "/callCenter",
		name: "callCenter",
		component: () => import("@/views/mine/callCenter.vue")
	},
  // 常见问题
	{
		path: "/helpDetail",
		name: "helpDetail",
		component: () => import("@/views/mine/helpDetail.vue")
	},
	// 隐私协议
	{
		path: "/privacyAgreement",
		name: "privacyAgreement",
		component: () => import("@/views/mine/privacyAgreement.vue")
	},
	//联系我们
	{
		path: "/contact",
		name: "contact",
		component: () => import("@/views/mine/contact.vue")
	},
	{
		path: "/transferMainManager",
		name: "transferMainManager",
		component: () => import("@/views/mine/transferMainManager.vue")
	},
]
